import { MOBILE_BREAKPOINT } from "@utils/consts/const";
import { defineStore } from 'pinia';

export const useLayoutStore = defineStore('layout',{
 state(){
    return{
        isMobile:false
    }
 }
})